import React, { useState, useRef } from "react";
import { careerEndpoints } from "../../services/api";
const { RETRAINERSHIP_API } = careerEndpoints;

export default function RetainershipForm() {
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    graduatedFrom: "",
    yog: "",
    currentlyWorking: "",
    designation: "",
    pqe: "",
    city: "",
  });

  const [loading, setLoading] = useState(false);
  const fileInputRef = useRef(null);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!fileInputRef.current.files[0]) {
      alert("Please upload a file.");
      return;
    }

    setLoading(true);
    const formDataToSend = new FormData();
    Object.entries(formData).forEach(([key, value]) => {
      formDataToSend.append(key, value);
    });
    formDataToSend.append("file", fileInputRef.current.files[0]);

    try {
      const response = await fetch(RETRAINERSHIP_API, {
        method: "POST",
        body: formDataToSend,
      });

      if (response.ok) {
        alert("Retainership form submitted successfully!");
        setFormData({
          fullName: "",
          email: "",
          graduatedFrom: "",
          yog: "",
          currentlyWorking: "",
          designation: "",
          pqe: "",
          city: "",
        });
        fileInputRef.current.value = "";
      } else {
        alert("Submission failed. Please try again.");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("Something went wrong. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-lg mx-auto p-6 bg-white rounded-lg shadow-md">
      <h2 className="text-2xl font-bold text-center mb-4">Apply Now!</h2>
      <form onSubmit={handleSubmit} className="space-y-4">
        <input type="text" name="fullName" value={formData.fullName} onChange={handleChange} placeholder="Full Name" className="w-full p-2 border rounded" required />
        <input type="email" name="email" value={formData.email} onChange={handleChange} placeholder="Email" className="w-full p-2 border rounded" required />
        <input type="text" name="graduatedFrom" value={formData.graduatedFrom} onChange={handleChange} placeholder="Graduated From" className="w-full p-2 border rounded" required />
        <input type="number" name="yog" value={formData.yog} onChange={handleChange} placeholder="Year of Graduation" className="w-full p-2 border rounded" required />
        <input type="text" name="currentlyWorking" value={formData.currentlyWorking} onChange={handleChange} placeholder="Currently Working At" className="w-full p-2 border rounded" required />
        <input type="text" name="designation" value={formData.designation} onChange={handleChange} placeholder="Designation" className="w-full p-2 border rounded" required />
        <input type="number" name="pqe" value={formData.pqe} onChange={handleChange} placeholder="Post Qualification Experience (Years)" className="w-full p-2 border rounded" required />
        <input type="text" name="city" value={formData.city} onChange={handleChange} placeholder="City" className="w-full p-2 border rounded" required />
        <input type="file" ref={fileInputRef} className="w-full p-2 border rounded" required />

        <button type="submit" className="w-full bg-[#C9A227] text-[#0F172A] p-2 rounded-lg font-semibold hover:bg-[#B79527] transition duration-300" disabled={loading}>
          {loading ? "Submitting..." : "Submit Application"}
        </button>
      </form>
    </div>
  );
}
